import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import moment from "moment";
import Repo from "../../Repository/Repo";

const initialState = {
  loading: false,
  error: "",
  vehicleReports: [],
};

export const getVehicleReport = createAsyncThunk(
  "vReport/fetchvReport",
  (arg) => {
    return Repo.vehicle({
      request: {
        method: "getVehicleReport",
        data: {
          ...arg,
        },
      },
    })
      .then(({ data }) => data.response.data.vehicleExpenseArr)
      .catch((err) => console.log(err));
  }
);

export const vehicleReportSlice = createSlice({
  name: "vehicleReport",
  initialState,
  reducers: {
    vehicleExpenseAdded: (state, action) => {
      let date = moment().format("DD-MM-YYYY");
      let { checkIn } = action.payload;
      let info = action.payload?.driverName;
      const { driverName, fuelAverage, vehicleName } = info;
      state.vehicleReports.unshift({
        driverName,
        fuelAverage,
        vehicleName,
        date,
        checkIn,
      });
    },
    vehicleUpdated: (state, action) => {
      const { key, val } = action.payload;
      if (key == "index") {
        const { index } = action.payload;
        state.vehicles[index] = val;
      } else {
        let foundIndex = state.vehicles.findIndex(
          (item) => item._id == val._id
        );
        state.vehicles[foundIndex] = val;
      }
    },
    vehicleRemove: (state, action) => {
      const { key, val } = action.payload;
      if (key == "index") {
        state.vehicles.splice(val, 1);
      } else {
        let foundIndex = state.vehicles.findIndex((item) => item._id == val);
        state.vehicles.splice(foundIndex, 1);
      }
    },
    vehicleReportsClear: (state) => {
      state.vehicleReports = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getVehicleReport.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getVehicleReport.fulfilled, (state, action) => {
      state.loading = false;
      state.vehicleReports = action.payload;
      state.error = "";
    });
    builder.addCase(getVehicleReport.rejected, (state, action) => {
      state.loading = false;
      state.vehicleReports = [];
      state.error = action.error.message;
    });
  },
});

export const {
  vehicleExpenseAdded,
  vehicleRemove,
  vehicleReportsClear,
  vehicleUpdated,
} = vehicleReportSlice.actions;

export default vehicleReportSlice.reducer;
